export default __webpack_public_path__ + "static/media/WindDirection.4baa0faf.svg";